import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FinaceRoutingModule } from './finace-routing.module';
import { AccountListComponent } from './account/account-list/account-list.component';
import { AccountCrudComponent } from './account/account-crud/account-crud.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JournelListComponent } from './journel/journel-list/journel-list.component';
import { JournelCrudComponent } from './journel/journel-crud/journel-crud.component';
import { LedgerListComponent } from './ledger/ledger-list/ledger-list.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { LedgerComponent } from './ledger/ledger/ledger.component';
import { CashbookListComponent } from './cashbook/cashbook-list/cashbook-list.component';
import { CashbookCrudComponent } from './cashbook/cashbook-crud/cashbook-crud.component';
import { FinanceReportComponent } from './finance-report/finance-report.component';
import { TransactionsComponent } from './transaction/transactions/transactions.component';
import { ManageTransactionComponent } from './transaction/manage-transaction/manage-transaction.component';
import { ManageTransactionEntryComponent } from './transaction/manage-transaction/manage-transaction-entry/manage-transaction-entry.component';
import { ProfitLossComponent } from './profit&Loss/profit-loss.component';
import { LedgerReportComponent } from './ledger-report/ledger-report.component';
import { VoucherListComponent } from './voucher/voucher-list/voucher-list.component';
import { ManageVoucherComponent } from './voucher/manage-voucher/manage-voucher.component';
import { VoucherEntriesComponent } from './voucher/voucher-entries/voucher-entries.component';
import { HttpClientModule } from '@angular/common/http';
import { BalanceSheetComponent } from './balance-sheet/balance-sheet.component';

@NgModule({
  declarations: [
    AccountListComponent,
    AccountCrudComponent,
    JournelListComponent,
    JournelCrudComponent,
    LedgerListComponent,
    LedgerComponent,
    CashbookCrudComponent,
    CashbookListComponent,
    FinanceReportComponent,
    TransactionsComponent,
    ManageTransactionComponent,
    ManageTransactionEntryComponent,
    ProfitLossComponent,
    LedgerReportComponent,
    VoucherListComponent,
    ManageVoucherComponent,
    VoucherEntriesComponent,
    BalanceSheetComponent,
  ],
  imports: [
    CommonModule,
    FinaceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PerfectScrollbarModule,
    HttpClientModule
  ],
})
export class FinaceModule {}
